
import React from "react";
import { Archive, CalendarDays, Moon, Sun } from "lucide-react";
import { Button } from "../ui/button";
import { useTheme } from "../../providers/ThemeProvider";
import InfoModal from "../modals/InfoModal";
import HintsButton from "../HintsButton";

function Header() {
  const { theme, toggleTheme } = useTheme();
  const search = typeof window !== "undefined" ? window.location.search : "";
  const isArchivePage =
    new URLSearchParams(search).get("page") === "archive";
  const archiveHref = isArchivePage ? "/" : "/?page=archive";
  const archiveButtonLabel = isArchivePage ? "Today's Puzzle" : "Archive";
  const archiveButtonAria = isArchivePage
    ? "Return to today's puzzle"
    : "Open archive page";

  return (
    <header className="grid grid-cols-[auto_1fr_auto] items-center gap-2 px-2 sm:px-4 py-2">
      <div className="flex items-center gap-1 sm:gap-2 justify-self-start">
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleTheme}
          className="h-10 w-10"
        >
          {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>
        <Button asChild variant="ghost" size="sm" className="h-10 px-2 sm:px-3">
          <a
            href={archiveHref}
            aria-label={archiveButtonAria}
            className="inline-flex items-center gap-1.5"
          >
            {isArchivePage ? (
              <CalendarDays className="h-4 w-4" />
            ) : (
              <Archive className="h-4 w-4" />
            )}
            <span className="hidden sm:inline text-xs sm:text-sm">{archiveButtonLabel}</span>
          </a>
        </Button>
      </div>
      <h1 className="truncate px-1 font-['Geometric_Slabserif_703'] font-extrabold text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl text-center leading-tight justify-self-center">
        Islamic Connections
      </h1>
      <div className="flex items-center gap-1 sm:gap-2 justify-self-end">
        <HintsButton />
        <InfoModal />
      </div>
    </header>
  );
}

export default Header;
